import { IComponentController, IComponentOptions } from 'angular';

import { IFontStyleModel } from '../../..';
import { TextCase } from '../../../providers';
import template from './style-specimen.html';

export class StyleSpecimenComponentBindings {
    font?: IFontStyleModel;
    // specify text explicitly, this will override autogeneration
    customText?: string;
    // size in pixels
    size = 0;
    // whole number percentage to scale the font-size by.
    scale = 100;
    // set text case for sample.
    case: TextCase = 'sentence';

    label?: string;
    labelOnly?: boolean;

    // save/buy button settings
    showBuyButton?: boolean;
    showSaveButton?: boolean;
    showTrialButton?: boolean;

    variationSettings?: Record<string, number>;

    specimenLinkTo: 'family' | 'style' | 'none' = 'none';
    onLabelClicked?: (args: {
        $event: Event;
        style?: IFontStyleModel;
    }) => void = undefined;
}

export class StyleSpecimenComponent
    extends StyleSpecimenComponentBindings
    implements IComponentController
{
    constructor() {
        super();
    }

    labelClicked($event: Event): void {
        $event.preventDefault();
        this.onLabelClicked &&
            this.onLabelClicked({ $event, style: this.font });
    }
}

export const StyleSpecimenComponentOptions: IComponentOptions = {
    controller: StyleSpecimenComponent,
    bindings: {
        // font style to display
        font: '<',
        // specify text explicitly
        customText: '<?',
        // size in pixels
        size: '<?',
        // % scale to apply to size
        scale: '<?',
        // variation settings object
        variationSettings: '<?',
        // set text case for sample.
        case: '<?',
        label: '<?',
        labelOnly: '<?',

        specimenLinkTo: '@?',
        // add ? so angular won't set a defaul noop handler so we can test whether to display the last > in the label indicating
        // the label is an interactive component.
        onLabelClicked: '&?',

        // buy button
        showBuyButton: '<',

        // save button
        showSaveButton: '<',
    },
    template: template,
};
